<ng-container *ngIf="loading; then loadingSpinner else validation"></ng-container>
<ng-template #loadingSpinner>
    <app-spinner-overlay></app-spinner-overlay>
</ng-template>

<ng-template #validation>
    <ng-container *ngIf="isValid; then register else error"></ng-container>
</ng-template>

<ng-template #register>
    <div class="container">
        <div class="columns" style="height: 100%;">
            <div class="column is-2"></div>
            <div class="column">
                <div class="card has-round-border"
                     style="box-shadow: 0 4px 5px 2px rgba(0, 0, 0, 0.3); padding: 5px;margin: auto;">
                    <form [formGroup]="userForm">
                        <div class="title is-4 is-uppercase has-text-centered is-bold"
                             style="color: #35566E; padding-top: 10px; margin-bottom: 20px">Registrieren
                        </div>
                        <app-notification *ngIf="errorMessage" content="{{errorMessage}}" display="true" error="true"
                                          timeOut="0"></app-notification>
                        <div style="display: flex; align-items: center; flex-direction: column">
                            <div class="control" id="gener" style="display: flex; justify-content: start; width: 90%">
                                <label class="radio">
                                    <input formControlName="title" name="title" type="radio" value="Herr"/>
                                    Herr
                                </label>
                                <label class="radio">
                                    <input formControlName="title" name="title" type="radio" value="Frau"/>
                                    Frau
                                </label>
                            </div>

                            <input [ngClass]="{'has-error': hasError(userForm.get('firstname'))}" class="login border-input form-input" formControlName="firstname" placeholder="Vorname"
                                   type="text"/>
                            <input [ngClass]="{'has-error':  hasError(userForm.get('lastname'))}" class=" login border-input form-input" formControlName="lastname" placeholder="Nachname"
                                   type="text"/>

                            <input [ngClass]="{'has-error':  hasError(userForm.get('mail'))}" class="login border-input form-input" formControlName="mail" placeholder="E-Mail Adresse"
                                   type="email" [readOnly]="true"/>

                            <input [ngClass]="{'has-error':  hasError(userForm.get('password'))}" class="login border-input form-input" formControlName="password" id="password"
                                   placeholder="Passwort"
                                   type="password"/>

                            <p style="font-size: 9px">
            <span [ngStyle]="userForm.controls['password'].hasError('required') || userForm.controls['password'].hasError('minlength') ? {'color':'black'} : {'color':'green'}"
                  class="mr-2">8 Zeichen</span>
                                <span [ngStyle]="userForm.controls['password'].hasError('required') || userForm.controls['password'].hasError('hasNumber') ? {'color':'black'} : {'color':'green'}"
                                      class="mr-2">Zahl</span>
                                <span [ngStyle]="userForm.controls['password'].hasError('required') || userForm.controls['password'].hasError('hasBigLetter') ? {'color':'black'} : {'color':'green'}"
                                      class="mr-2">Großbuchstaben</span>
                                <span [ngStyle]="userForm.controls['password'].hasError('required') || userForm.controls['password'].hasError('hasSmallLetter') ? {'color':'black'} : {'color':'green'}"
                                      class="mr-2">Kleinbuchstaben</span>
                                <span [ngStyle]="userForm.controls['password'].hasError('required') || userForm.controls['password'].hasError('hasSpecialCharacter') ? {'color':'black'} : {'color':'green'}"
                                      class="mr-2">Sonderzeichen</span>
                            </p>

                            <input [ngClass]="{'has-error': userForm.controls['passwordConfirm'].hasError('NoPassswordMatch')}" class="login border-input form-input" formControlName="passwordConfirm"
                                   placeholder="Passwort Wiederholen"
                                   type="password"/>

                            <button (click)="doRegister()" class="button buy-button is-size-7 has-round-border"
                                    style="height: 40px; width: 90% !important; background-color: #73B1D6 !important; margin-top: 10px">
                                <p class="is-bold is-uppercase" style="font-size: 15px">Registrieren</p>
                            </button>

                            <div class="mt-3">
                                <a routerLink="/login" style="color: #73b1D6;">Bereits registriert? Jetzt anmelden</a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="column is-2"></div>
        </div>
    </div>
</ng-template>
<ng-template #error>
    <div class="container">
        <mat-card appearance="outlined" class="register-card">
            <mat-card-header>
                <mat-card-title>Entschuldigung</mat-card-title>
                <mat-card-subtitle>Einladung ungültig oder abgelaufen</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
                <p>Der verwendete Einladungslink ist ungültig oder abgelaufen.</p>
                <p>Bitte fragen Sie Ihren Kontakt nach einer neuen Einladung.</p>
            </mat-card-content>
        </mat-card>
    </div>
</ng-template>


